<style lang="scss">
.media-side-by-side {
  .visitor-image-large {
    max-height: 85vh;
    max-width: 100%;;
  }

  .center-image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<template>
  <div class="container-fluid p-0 p-relative media-side-by-side">
    <div class="row">
      <div v-for="(url, index) in imageUrls" :key="index" :class="getNumberOfColumns(imageUrls.length)" class="py-0">
        <img class="visitor-image-large center-image" :src="url">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'images-side-by-side-modal',
    props: {
      imageUrls: {
        type: Array,
        required: true
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      getNumberOfColumns(noOfUrls){
        if(noOfUrls === 2){
          return 'col-6';
        }
        else if(noOfUrls === 3){
          return 'col-4';
        }

        return 'col-12';
      }
    },
  };
</script>
